<template>
    <div class="text-center">
        <v-dialog v-model="dialog" width="500" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" style="width: 100%" x-small> <v-icon dark large left small>monetization_on</v-icon> Adicionar despesa </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline primary white--text">{{ $t("Pagamento") }}</v-card-title>

                <v-card-text style="height: 200px">
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
                        <v-layout wrap ma-2 py-8>
                            <v-flex xs12>
                                <v-select v-model="detail" :rules="[rules.required]" :items="expensesOptions" item-value="id" item-text="name" label="Tipo de Despesa"></v-select>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field v-model="value" :rules="[rules.required, rules.money]" :label="$t('Valor')"
                                    v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##']" return-masked-value prefix="R$" type="number" required />
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-layout wrap>
                        <v-flex xs6>
                            <v-btn color="success" @click="validate" style="width: 100%">
                                <v-icon dark left>check_circle</v-icon>
                                {{ $t("Finalizar") }}
                            </v-btn>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn color="error" @click="onClose" style="width: 100%" :disabled="$store.getters.isLoading" :loading="$store.getters.isLoading">
                                <v-icon dark left>cancel</v-icon>
                                {{ $t("Cancelar") }}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

import expensesOptions from "@/assets/json/expenses.json";

export default {
    directives: { mask },

    props: {
        store: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            dialog: false,
            expensesOptions,
            value: null,
            detail: null,
        };
    },

    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.$http
                    .post(`expenses`, { value: this.value, detail: this.detail, store: this.store })
                    .then((result) => {
                        this.onClose();
                        this.$emit("update");
                        this.$eventHub.$emit("msgSuccess", result.message ? result.message : this.$t("Despesa inserida com sucesso."));
                    })
                    .catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao inserir despesa."));
                    });
            }
        },
        onClose() {
            this.dialog = false;
            this.value = null;
            this.$refs.form.reset();
            this.detail = null;
        },
    },
};
</script>